import React from 'react';

const WindowLinkExpired = () => {

  return (
    <div className="text-box-expired">
      Link wygasł
    </div>
  );
};

export default WindowLinkExpired;